import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imgResize',
})
export class ImgResizePipe implements PipeTransform {

  SIZES: any = {
    thumb: '/fit-in/80x80',
    small: '/fit-in/200x200',
    medium: '/fit-in/400x400',
    large: '/fit-in/800x800',
  };
  // Note: This is specific to aws cloudfront.net
  transform(val?: string, size?: string, bg?: string, quality?: number): string {
    if (!val) return '';
    const splitBy = 'cloudfront.net';
    const url = val.split(splitBy);

    const filterConfig = [splitBy,];
    
    if(bg) filterConfig.push(`/filters:autojpg()/filters:background_color(${bg})`);
    if(size) filterConfig.push(this.SIZES[size]);
    if(quality) filterConfig.push(`/filters:quality(${quality})`);
    return url.join(filterConfig.join(''));
  }
}